// extracted by mini-css-extract-plugin
module.exports = {"root":"ShadowWrapper_root__1MIC_"};